// Posts a form's fields as JSON to the backend in backend/index.js.
// Resolves with { ok: true } or throws an Error carrying a user-facing message.
export async function submitForm(endpoint, form) {
  const data = Object.fromEntries(new FormData(form).entries());
  let res;
  try {
    res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  } catch {
    throw new Error('Network error. Please try again, or email info@astridfirst.com.');
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body.error || 'Something went wrong. Please try again.');
  }
  return body;
}
